const PUBLIC_HOME_HANDOFF_KEY = 'stocktag_public_home_handoff';
const PUBLIC_HOME_HANDOFF_TTL_MS = 5 * 60 * 1000;

export const writePublicHomeHandoff = (payload) => {
  if (typeof window === 'undefined' || !payload || typeof payload !== 'object') return;

  try {
    sessionStorage.setItem(PUBLIC_HOME_HANDOFF_KEY, JSON.stringify({
      ...payload,
      createdAt: Date.now()
    }));
  } catch {
    // noop
  }
};

export const consumePublicHomeHandoff = () => {
  if (typeof window === 'undefined') return null;

  try {
    const raw = sessionStorage.getItem(PUBLIC_HOME_HANDOFF_KEY);
    if (!raw) return null;
    sessionStorage.removeItem(PUBLIC_HOME_HANDOFF_KEY);

    const parsed = JSON.parse(raw);
    const createdAt = Number(parsed?.createdAt || 0);
    if (!Number.isFinite(createdAt) || (Date.now() - createdAt) > PUBLIC_HOME_HANDOFF_TTL_MS) {
      return null;
    }

    return parsed;
  } catch {
    return null;
  }
};
